'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _utils = require('./utils');
var utils = _interopRequireWildcard(_utils);
var _EvaluationData = require('./EvaluationData');
var _EvaluationData2 = _interopRequireDefault(_EvaluationData);
var _BaseExperimentEvaluator = require('./BaseExperimentEvaluator');
var _BaseExperimentEvaluator2 = _interopRequireDefault(_BaseExperimentEvaluator);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * Evaluator for experiment evaluation and logging
 *
 * @implements {BaseExperimentEvaluator}
 */
var ExperimentEvaluator = function (_BaseExperimentEvalua) {
  _inherits(ExperimentEvaluator, _BaseExperimentEvalua);
  function ExperimentEvaluator() {
    _classCallCheck(this, ExperimentEvaluator);
    return _possibleConstructorReturn(this, (ExperimentEvaluator.__proto__ || Object.getPrototypeOf(ExperimentEvaluator)).apply(this, arguments));
  }
  _createClass(ExperimentEvaluator, [{
    key: 'evaluateExperiment',
    // jsdoc defined in parent
    value: function evaluateExperiment(experimentId) {
      var evaluationData = this.getEvaluatedExperiments()[experimentId];
      if (evaluationData) {
        return evaluationData; // eslint-disable-line consistent-return
      }
      return utils.getEvaluationDataWithException(experimentId); // eslint-disable-line consistent-return
    }

    // jsdoc defined in parent
  }, {
    key: 'evaluateAllExperiments',
    value: function evaluateAllExperiments() {
      var evaluationDatas = this.getEvaluatedExperiments();
      if (Object.keys(evaluationDatas).length > 0) {
        return evaluationDatas; // eslint-disable-line consistent-return
      }
      return utils.getEmptyEvaluationData(); // eslint-disable-line consistent-return
    }

    // jsdoc defined in parent
  }, {
    key: 'evaluateExperimentAndLog',
    value: function evaluateExperimentAndLog(experimentId, loggerParams) {
      var evaluationData = this.evaluateExperiment(experimentId);
      this.logExperiment(evaluationData, loggerParams);
      return evaluationData; // eslint-disable-line consistent-return
    }

    // jsdoc defined in parent
    // eslint-disable-next-line complexity
  }, {
    key: 'logExperiment',
    value: function logExperiment(evaluationData, loggerParams) {
      if (!evaluationData) {
        return;
      }
      if (typeof evaluationData === 'number') {
        this.evaluateExperimentAndLog(evaluationData, loggerParams);
        return;
      }
      var experimentId = evaluationData.experimentKey.experimentId;
      if (this.exposedExperiments.hasOwnProperty(experimentId)) {
        return;
      }
      evaluationData = new _EvaluationData2.default(evaluationData);
      var exposureLoggers = this.getExposureLoggers();
      for (var i = 0; i < exposureLoggers.length; ++i) {
        try {
          exposureLoggers[i].logExposure(evaluationData, loggerParams);
        } catch (ex) {
          // This is only an additional fallback security layer to guarantee all loggers are executed, the logger should manage the errors and log if needed.
        }
      }
      this.exposedExperiments[experimentId] = true;
    }
  }]);
  return ExperimentEvaluator;
}(_BaseExperimentEvaluator2.default);
exports.default = ExperimentEvaluator;